import { Form, Radio, Typography } from 'antd';
import { useIntl } from 'react-intl';
import {
  QuestFilterDateBy,
  QuestReportType,
} from '@/core/domain/questReport/Reports/WorkOrder/WorkOrder.types';

const ReportWorkOrderFilterByDateField: React.FC = () => {
  const intl = useIntl();
  const { Title } = Typography;
  return (
    <>
      <Title level={5}>
        {intl.formatMessage({
          id: 'movementWorkOrdersReport.form.filterByDate',
        })}
      </Title>

      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const reportType = getFieldValue('reportType');

          return (
            <>
              <Form.Item
                name="filterDateBy"
                initialValue={QuestFilterDateBy.authorization}
                noStyle
              >
                <Radio.Group
                  optionType="button"
                  buttonStyle="solid"
                  size="large"
                >
                  <Radio value={QuestFilterDateBy.entry}>
                    {intl.formatMessage({
                      id: 'movementWorkOrdersReport.form.filterByDate.entrance',
                    })}
                  </Radio>

                  <Radio value={QuestFilterDateBy.authorization}>
                    {intl.formatMessage({
                      id: 'movementWorkOrdersReport.form.filterByDate.authorization',
                    })}
                  </Radio>

                  {reportType !== QuestReportType.partStatus && (
                    <Radio value={QuestFilterDateBy.closing}>
                      {intl.formatMessage({
                        id: 'movementWorkOrdersReport.form.filterByDate.shutdown',
                      })}
                    </Radio>
                  )}

                  <Radio value={QuestFilterDateBy.foreseenDelivery}>
                    {intl.formatMessage({
                      id: 'movementWorkOrdersReport.form.filterByDate.expectedDeparture',
                    })}
                  </Radio>

                  {reportType !== QuestReportType.partStatus && (
                    <Radio value={QuestFilterDateBy.delivery}>
                      {intl.formatMessage({
                        id: 'movementWorkOrdersReport.form.filterByDate.delivery',
                      })}
                    </Radio>
                  )}
                </Radio.Group>
              </Form.Item>
            </>
          );
        }}
      </Form.Item>
    </>
  );
};

export default ReportWorkOrderFilterByDateField;
